import { StandardWebFormMoreSettings } from './StandardWebFormMoreSettings'

export const CalculationWebFormMoreSettings = entry => {
  return <StandardWebFormMoreSettings decimalPlace={true} {...entry} />
}
